<div
    class="sticky-notification"
    [ngClass]="type">
    <ng-content></ng-content>
</div>
